module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_sns_03-e83ee5c901dcd63df217e642d0e05501.jpg";